import {createFeatureSelector, createSelector} from '@ngrx/store';
import {MxSelector, MxSelectorCreator} from '@aviary/store/store.types';
import {ACTIVE_ROUTER_TAB_FEATURE_KEY, ActiveRouterTabState} from '@aviary/store/active-router-tab/active-router-tab.types';
import {MxRouterTabs} from '@aviary/store/router/router.types';

// For each app to call in an adapter file, using its own RouteName type and ROUTER_TABS_FOR.
export function createActiveRouterTabSelectors<RouteNameType extends string = string>(
  getRouterTabsFor: (parentRouteName: RouteNameType) => MxRouterTabs<RouteNameType> | undefined
) {
  const entireState: MxSelector<ActiveRouterTabState> = createFeatureSelector<ActiveRouterTabState>(ACTIVE_ROUTER_TAB_FEATURE_KEY);

  const cachedTabRouteNameFor: MxSelectorCreator<[RouteNameType], RouteNameType> =
    parentRouteName => createSelector(
      entireState,
      state => {
        const cachedRouteName: string | undefined = state[parentRouteName];
        if (cachedRouteName) return cachedRouteName as RouteNameType;

        // We don't already have a cached value, so pick the first tab's route name.  If that's not there (direct Aviary call) just cache the parent route name.
        return (getRouterTabsFor(parentRouteName)?.[0]?.routeName ?? parentRouteName) as RouteNameType;
      }
    );

  return {
    entireState,
    cachedTabRouteNameFor
  } as const;
}

// For Aviary use only.  With an empty routerTabsFor map, cachedTabRouteNameFor will just fall back to parentRouteName.
export const ActiveRouterTabSelectors = createActiveRouterTabSelectors<string>(() => undefined);
